import React, { memo, useCallback } from 'react';
import AuthScreenLayout from '../../../shared/AuthScreenLayout';
import ControlledError from '../../../shared/FormHandler/ControlledError/ControlledError';
import ControlledInput from '../../../shared/FormHandler/ControlledInput/ControlledInput';
import OtpInput from 'react-otp-input';
import { useStyles } from '../styles';
import { ButtonLoader } from 'modules/views/shared';
import { GeneralModel } from 'modules/models';
import { useForm } from 'utils/useForm';
import { formatPhoneNumber, getConditionalDefaultValue, ruleMap } from 'utils';
import { STYLE } from '../../../../../constants';
import { Link } from 'react-router-dom';
import { Grid } from '@material-ui/core';

export interface IOTPInputProps {
  mobilePhoneNumber: string;
  setStep: (step: number) => void;
  onSubmitOTP: (data: any) => void;
  loadingStatus: GeneralModel.ILoadingStatus;
}

const OTPInput = ({ setStep, loadingStatus, onSubmitOTP, mobilePhoneNumber }: IOTPInputProps) => {
  const classes = useStyles();

  const { model, errors, onSubmit, onChange } = useForm<any>({
    initValues: { otp: '' },
    formRules: { otp: { required: true, rules: [ruleMap.isEqualLength], args: [{ length: 5 }] } },
    onSubmitCallback: onSubmitOTP,
  });

  const onChangeHandler = useCallback(
    (otp: string) => {
      onChange(prevState => ({
        ...prevState,
        otp: otp?.toUpperCase(),
      }));
    },
    [onChange]
  );

  return (
    <AuthScreenLayout
      title={'Enter 5 digit PIN Code'}
      subtitle={`The PIN was texted to the phone number ${formatPhoneNumber(mobilePhoneNumber)}`}
      links={
        <Grid container={true} style={{ marginBottom: 20 }}>
          <Grid item={true} xs={8} md={8}>
            <a style={{ textDecoration: 'underline', color: '#007bff', cursor: 'pointer' }} onClick={() => setStep(0)}>
              Go to Reset your Password
            </a>
          </Grid>
          <Grid item={true} xs={4} md={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Link to="/" style={{ textDecoration: 'underline' }}>
              Go to Sign In
            </Link>
          </Grid>
        </Grid>
      }
      renderContent={() => (
        <div style={{ marginTop: 20 }}>
          <ControlledError
            show={!!errors.otp}
            error={getConditionalDefaultValue(errors.otp && errors.otp === 'is required', 'Please enter OTP', `Please enter OTP`)}
            styleClass={classes.resetPasswordError}
          >
            <ControlledInput label="" required={true} dataTestId="otp-wrapper">
              <OtpInput
                value={model.otp}
                onChange={onChangeHandler}
                numInputs={5}
                shouldAutoFocus={true}
                renderSeparator={<span style={{ marginRight: 20 }} />}
                inputStyle={{
                  width: '2rem',
                  height: '3rem',
                  marginBottom: 10,
                  border: 0,
                  borderBottom: `1px solid`,
                  borderBottomColor: !!errors.otp ? STYLE.COLOR.ERROR : STYLE.COLOR.BLACK,
                }}
                renderInput={props => <input {...props} />}
              />
            </ControlledInput>
          </ControlledError>
          <div className={classes.resetPasswordBtnWrapper}>
            <ButtonLoader
              className={classes.resetPasswordBtn}
              color="primary"
              variant="contained"
              fullWidth={true}
              size="large"
              type="submit"
              disabled={false}
              onClick={onSubmit}
              data-testid="otp-verify-btn"
              isLoading={loadingStatus?.isLoading}
              text="Verify"
              loadingText="Verifying..."
            />
          </div>
        </div>
      )}
    />
  );
};

export default memo(OTPInput);
